import PropTypes from 'prop-types'
import { logoMap } from '../data-maps/club-logo-map'

const MatchesCard = ({ fixture }) => {
  if (!fixture || !fixture.participants) return null

  const dateObj = new Date(fixture.starting_at.replace(' ', 'T'))
  const now = new Date()

  let home = fixture.participants.find((p) => p.meta.location === 'home') || {}
  let away = fixture.participants.find((p) => p.meta.location === 'away') || {}

  const localTime = dateObj
    .toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
    .toUpperCase()

  return (
    <div className='matches-card abstract-bg'>
      <div className='matches-row'>
        {/* Match Time */}
        <div className='match-time'>{localTime}</div>

        {/* Teams */}
        <div className='teams-col'>
          {/* Home */}
          <div className='team-row'>
            <img
              src={logoMap[home.id] || home.image_path}
              alt={home.name}
              className='team-logo '
            />
            <p>{home.name}</p>
          </div>
          {/* Away */}
          <div className='team-row'>
            <img
              src={logoMap[away.id] || away.image_path}
              alt={away.name}
              className='team-logo '
            />
            <p>{away.name}</p>
          </div>
        </div>

        {/* position */}
        <div className='positions-col'>
          <p>{dateObj < now ? home.goals || 0 : '-'}</p>
          <p>{dateObj < now ? away.goals || 0 : '-'}</p>
        </div>
      </div>
    </div>
  )
}

export default MatchesCard

// prop validation
MatchesCard.propTypes = {
  fixture: PropTypes.shape({
    id: PropTypes.number.isRequired,
    starting_at: PropTypes.string.isRequired,
    participants: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        image_path: PropTypes.string,
        meta: PropTypes.shape({
          location: PropTypes.string.isRequired,
        }).isRequired,
        goals: PropTypes.number,
      })
    ).isRequired,
  }).isRequired,
}
